import {createActions} from 'rlink-flux';
import {Identity} from 'rlink-utils/functional';

export default createActions({
  PriceLoaded: Identity,
  ModalContentLoaded: Identity,
  OpenModal: Identity,
  CloseModal: Identity,
});



// WEBPACK FOOTER //
// ./lib/rlink-shop/actions.js